import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kui-moving-image',
  templateUrl: './moving-image.component.html',
  styleUrls: ['./moving-image.component.scss']
})
export class MovingImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
